import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { keyframes } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface FooterProps {
  variant?: 'bar' | 'inline';
}

export const Footer: React.FC<FooterProps> = ({ variant = 'bar' }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        py: 1.5,
        px: 2,
        position: 'relative',
        zIndex: 1,
        flexShrink: 0,
        ...(variant === 'inline'
          ? { mt: 3 }
          : isDark
          ? {
              background: 'linear-gradient(135deg, #1d388d 0%, #0d1f4d 50%, #1d388d 100%)',
              backgroundSize: '200% 200%',
              animation: `${keyframes`
                0% { background-position: 0% 50%; }
                50% { background-position: 100% 50%; }
                100% { background-position: 0% 50%; }
              `} 15s ease infinite`,
            }
          : { bgcolor: 'grey.200', borderTop: 1, borderColor: 'divider' }),
      }}
    >
      <Typography variant="caption" sx={{ color: isDark ? 'rgba(255, 255, 255, 0.8)' : 'text.secondary' }}>
        {t('common.poweredBy')}
      </Typography>
      <Box
        component="img"
        src={isDark
          ? '/assets/waldevar-robotics-horizontal-white.png'
          : '/assets/waldevar-robotics-horizontal.png'}
        alt="Waldevar Robotics"
        sx={{ height: 16, width: 'auto', display: 'block' }}
      />
    </Box>
  );
};
